import { PluginConsumer } from '../../plugin-consumer';
import { PathCompletionProvider } from './path-completion-provider';

export function plugIn(editor: monaco.editor.IStandaloneCodeEditor, self: PluginConsumer) {
  monaco.languages.registerCompletionItemProvider(
    'typescript',
    new PathCompletionProvider(self.editorWorker.worker, self.projectStore)
  );
}
